export default {
  toolbar:{
    urgingMessage:'Urging Message',
    msgType: 'Message Type',
    processTrack:'Process Track',
    processTrackTips:'Failed to get process track!',
    goBack:'Go Back',
    goBackTo:'Go Back To',
    handledBy:'Handled By',
    toUserGroup:'Forward To User Group',
    toPersonnel:'Forward To Personnel',
    addHandler:'Add Handler',
    removeHandler:'Remove Handler',
    node:'Node',
    handler:'Handler',
    handlerGroup:'Handler Group',
    userGroupTips:'Failed to get user group',
    selectNode:'Please select a node',
    noChangeTips:'There is no change in the handler or handlerGroup under the node',
    urgingContentTips:'Please enter the urging content',
    urgingContentSize:'The urging content shall not exceed 500 characters',
    urgingMethodTips:'Please select at least one urging method',
    urgedSuccess:'Urged successfully',
    urgingFailed:'Urging failed',
    addSuccess:'Added handler successfully',
    failedAdd:'Failed to add handler',
    removeSuccess:'Remove the handler successfully',
    failedRemove:'Failed to remove handler',
    actionSuccess:'{action} successfully',
    actionFailed:'{action} failed'
  },
  nextStep:{
    selectPlaceholder:'Please select',
    getHandlerTips:'Handler is getting, please wait a moment',
    currentNode:'Current Node',
    cur_node_desc:'Current Node Desc',
    nextStep:'Next Step',
    node_desc:'Next Step Desc',
    assignee:'Assignee',
    addAssignee:'Add Assignee',
    assigneeGroup:'Assignee Group',
    circulator:'Circulated By',
    nodeMsg:'Please select the next node',
    assigneeMsg:'Please select the next assignee',
    nodeEmptyMsg:'Please select the next node first',
    addAssigneer: 'AddAssigneer',
    addAssigneeMsg: 'Please select add assigneer',
  },
  pageView:{
    msgType: 'Message type',
    validCodeMsg: 'Please choose at least one sending mode',
  },
  sealOrSign:{
    addSeal:'Add Seal',
    addSignature:'Add Sign',
    viewOther:'View other comments',
    chooseSeal:'Choose Seal',
    chooseSign:'Choose Sign',
    userDirections:'Directions for use',
    text1:'open the mobile phone and scan the QR code to create a signature on the mobile phone',
    text3:'check "Electronic Signature"',
    remark:'remark',
    text4:'the created electr sign can be used next time. select Electr Sign',
    click:'click',
    text2:'button to load (refresh) the signature picture',
    text5:'use your phone and scan to create a signature',
    text6:'Qr code is invalid, please click',
    refresh:'refresh',
    electSign:'electr sign',
    secondVerrifi:'Second Verification',
    phone: 'Phone',
    sendCode: 'Send Code',
    getValidCode: 'Get code',
    inputEnter: 'Please enter',
    validPhone:'Please enter your phone',
    validPhoneMsg:'Invalid cell phone number',
    validCode:'Please enter send code',
    validCodeMsg:'Get code is failure',
    validFail:'Valid is failure',
    countdown:'getting({key})',
    validSeal:'please select an electronic seal',
    validSign:'please select an electronic signature',
    validSealAndSign:'please select electronic seal and signature',
  },
  suggestion: 'Suggestion',
  saveComment: 'save it as common advice',
  commonComment: 'Common comments',
  vaildComment:'please enter your advice',
  validCommentRequired:'advice option is required',

  recipient: 'Recipient',
  chooseRecipient:'Please choose at least one recipient',
  distributeInstru:'Distribute instruction',
  validDistriInstru:'Please enter distribute instruction',
  createTime: 'Creation Time',
  creator: 'Creator',
  operateSuccess: 'Operation is successful',
  operateFail: 'Operation is failure',
  validSuccess: 'Validation is failure',
  noPerminss: 'No permissions',
  interfaceError: 'Interface error',
  buttonCancel: 'Cancel', // 取消
  buttonConfirm: 'Confirm', // 确定
  noData: 'No data yet', // 没有数据

  search: 'Search',
  searchPlaceholder: 'Please enter your name/employee number',
  selectMember:'Select Members',
  validSeleMember: 'Please select members',
  organization:'Organization',
  waitPersonnel:'Waiting to be selected',
  selectedPersonnel:'Selected',
  name:'Name',
  numId:'NumId',
  org:'Org',
  delete:'Delete',
  change:'Change',

  title:'Title',
  content:'Content',
  requestFailed:'API request failed'
  
}
